import { render, staticRenderFns } from "./round-editor.vue?vue&type=template&id=0369f869&scoped=true"
import script from "./round-editor.vue?vue&type=script&lang=js"
export * from "./round-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0369f869",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0369f869')) {
      api.createRecord('0369f869', component.options)
    } else {
      api.reload('0369f869', component.options)
    }
    module.hot.accept("./round-editor.vue?vue&type=template&id=0369f869&scoped=true", function () {
      api.rerender('0369f869', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-button/round-editor.vue"
export default component.exports